import { DeleteOutlined, WalletOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

export const Center = ({
  children,
  tone,
}: {
  children: React.ReactNode;
  tone?: "danger";
}) => (
  <div
    className={`flex min-h-[200px] items-center justify-center text-[13px] ${
      tone === "danger" ? "text-pos-danger-ink" : "text-pos-muted"
    }`}
  >
    {children}
  </div>
);

// Ред с клиент; tone="danger" е редът „Премахни отстъпка/надбавка" — същото
// поведение (селектира се, прилага се с „Премахни"/Enter), само по-ясен вид.
export const ClientRow = ({
  selected,
  label,
  percentLabel,
  onClick,
  clientId,
  onAccount = false,
  tone = "client",
}: {
  selected: boolean;
  label: string;
  percentLabel: string;
  onClick: () => void;
  clientId?: number;
  // маркер: клиентът може да закрива с „Плащане по сметка"
  onAccount?: boolean;
  tone?: "client" | "danger";
}) => {
  const { t } = useTranslation();
  const danger = tone === "danger";
  return (
    <button
      type="button"
      data-client-id={clientId}
      onClick={onClick}
      aria-pressed={selected}
      className={`flex w-full cursor-pointer items-center justify-between gap-2 rounded-[10px] border px-3.5 py-3 text-left transition-colors ${
        danger
          ? selected
            ? "border-pos-danger-ink bg-pos-danger-bg"
            : "border-pos-danger-brd bg-pos-danger-bg/60 hover:bg-pos-danger-bg"
          : selected
            ? "border-pos-accent bg-pos-marked"
            : "border-pos-line3 bg-pos-panel hover:bg-pos-canvas"
      }`}
    >
      <span className="flex min-w-0 items-center gap-2">
        {danger && (
          <DeleteOutlined className="shrink-0 text-[15px] text-pos-danger-ink" />
        )}
        <span
          className={`min-w-0 truncate text-sm font-semibold ${
            danger
              ? "text-pos-danger-ink"
              : selected
                ? "text-pos-accent-ink"
                : "text-pos-ink"
          }`}
        >
          {label}
        </span>
        {onAccount && (
          <span
            className={`inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-pos-accent/30 px-2 py-0.5 text-[10.5px] font-bold text-pos-accent-ink ${
              selected ? "bg-pos-card" : "bg-pos-marked"
            }`}
          >
            <WalletOutlined className="text-[11px]" />
            {t("clients.onAccountBadge")}
          </span>
        )}
      </span>
      <span
        className={`shrink-0 font-pos-mono text-[15px] font-bold ${
          danger ? "text-pos-danger-ink" : "text-pos-accent-ink"
        }`}
      >
        {percentLabel}
      </span>
    </button>
  );
};
